import { Directive, HostListener } from "@angular/core";

@Directive({
  selector: "[commonSelectAllRows]",
  standalone: true,
})
export class SelectAllRowsDirective {
  @HostListener("click", ["$event"])
  onCheckboxClicked(event: MouseEvent): void {
    const cbxElement = event.target as HTMLInputElement;
    const tableElement = cbxElement.closest("table");
    if (tableElement) {
      const rows = tableElement.querySelectorAll("tbody tr");
      rows.forEach((row) => row.classList.remove("selected"));
      if (cbxElement.checked) {
        rows.forEach((row) => row.classList.add("selected"));
      } else {
        rows.forEach((row) => row.classList.remove("selected"));
      }
    } else {
      new Error("Directive must be used inside of an table...");
    }
    event.stopPropagation();
  }
}
